
import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import TableContainer from '@material-ui/core/TableContainer';
import { Link } from 'react-router-dom';

import TableListFooter from 'core/TableListFooter';
import Layout from 'components/Dashboard/Layout';
import { ListContext, ListProvider } from 'core/ListProvider';
import AddIcon from '@material-ui/icons/Add';
import { YellowButton } from 'ui/Button';
import SearchWidget from 'form/SearchWidget';
import { UserContext, hasAccountPermission } from 'components/User';
import SemiTrailerTable from './ListTable';
import { ResponsiveTable } from 'ui/Table';
import { SelectButtonGroupWidget } from 'form/SelectButtonGroupWidget';


export default class SemiTrailerList extends Component {

  static contextType = UserContext;

  componentDidMount() {
    document.title = 'Полуприцепы';
  }

  onDetail = (item) => {
    this.props.history.push(`/semi_trailer/${item.id}`);
  };

  render() {
    const canAdd = hasAccountPermission(this.context, 'fleet.add_trailer');

    return (
      <ListProvider
        url={'fleet/trailer'}
      >
        <ListContext.Consumer>
          {context => {
            const { items } = context;
            const addButton = canAdd
              ? (
                <YellowButton component={Link} to={`/semi_trailer/add`} startIcon={<AddIcon />}>
                  Добавить полуприцеп
                </YellowButton>
              )
              : undefined;

            return (
              <Layout>
                <Layout.Header
                  title={'Полуприцепы'}
                  search={
                    <SearchWidget
                      value={context.filter.number__icontains}
                      onChange={(value) => context.setFilterValue('number__icontains', value)}
                    />
                  }
                  right={addButton}
                />
                <Layout.Filter>
                  <SelectButtonGroupWidget
                    value={context.filter.is_active}
                    options={[
                      {value: null, label: 'Все'},
                      {value: true, label: 'Активные'},
                      {value: false, label: 'Неактивные'},
                    ]}
                    onChange={(value) => context.setFilterValue('is_active', value)}
                  />
                </Layout.Filter>
                <Layout.ContentSimple>
                  <TableContainer component={Paper}>
                    <ResponsiveTable>
                      <SemiTrailerTable
                        items={items}
                        onDetail={(item) => this.onDetail(item)}
                      />
                      <TableListFooter colspan={5} />
                    </ResponsiveTable>
                  </TableContainer>
                </Layout.ContentSimple>
              </Layout>
            )
          }}
        </ListContext.Consumer>
      </ListProvider>
    )
  }
}
